import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Intro from '@app/layout/Intro.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { ResponsiveReservationList } from '@app/pages/reservations/ResponsiveReservationList.tsx';

interface ComponentProps {}

const ReservationListPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <ResponsiveLayout
        title={tr(`Reservations.reservationList`, `Reservation list`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_TIMESLOT_LIST_READ, PermissionTypesEnum.PERMISSION_TIMESLOT_LIST_RW]}
      >
        <ResponsiveReservationList />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(ReservationListPage, {
  onRedirecting: () => <Intro />,
});
